import * as React from "react";

import { Text, TranslationsProvider } from '@eo-locale/react';
import '@blueprintjs/core/lib/css/blueprint.css';
import { Tree, Classes } from "@blueprintjs/core";
import { Button, Card, Elevation, Overlay, Intent, Icon } from "@blueprintjs/core";
//import { Example } from '@blueprintjs/docs-theme';
//import { DialogExample } from './components/dialogExample';
import {
    Alignment,
    H5,
    Navbar,
    Toast,
    NavbarDivider,
    NavbarGroup,
    NavbarHeading,
    Toaster,
    Position,
    Code,
    MultistepDialog,
    DialogStep,
    ButtonProps,
    RadioGroup,
    Radio,
    NumericInput,
    Label,
} from "@blueprintjs/core";
import PanelNom from './PanelNom.tsx';
import PanelEmail from './PanelEmail.tsx';
import PanelPassword from './PanelPassword.tsx';
import PanelOnePassword from './PanelOnePassword.tsx';
import PanelEmailEtPassword from './PanelEmailEtPassword.tsx';
import PanelChoixType from './PanelChoixType.tsx';
import { type, userInfo } from "os";
import PanelIdentifiant from "./PanelIdentifiant.tsx";
import './home.css';

export type type_home = {
    value: undefined,
    isValidSignin: undefined,
    isValidLogin: undefined
}
export interface HomeProps {
    navFiles: string
    isnotconnected: string
    isnotlabo: string
    visible: boolean
    isOpenSign: boolean
    isOpenLogin: boolean
    menuVisibility: boolean
    state: type_home
    type_audio: string
    usernickname: { nickname: "" }
    usernom: string
    userprenom: string
    usertype: string
    handleOpen: () => void
    handleClose: () => void
    handleChange: () => void
    handleSendCnx: () => void
    handleSelectionChange: (ev) => void
    handleSelectionGetLogin: (ev) => void
    handleOpenLogin: () => void
    handleCloseLogin: () => void
    handleChangeLogin: () => void
    handleSendCnxLogin: () => void
}
export default class Home extends React.Component<HomeProps> {
    state = {
        ishelpvisio: 'none',
        ishelpstudentcnx: 'none',
        ishelpstudenttoolbar: 'none',
        ishelpsteachertoolbar: 'none',
        ishelpdivers: 'none',
        ishelpupload: 'none',
        ishelpinvit: 'none',
        ishelpvisio2: 'none'
    }
    constructor(props) {
        super(props);

        // this.handleChange = this.handleChange.bind(this);
    }

    render() {

        const { navFiles, state, isnotconnected, menuVisibility, isOpenSign, usernickname, isOpenLogin, usernom, userprenom, usertype, handleOpen, handleClose, handleChange, handleSendCnx, handleSelectionChange, handleSelectionGetLogin, handleOpenLogin, handleCloseLogin, handleChangeLogin, handleSendCnxLogin } = this.props;

        return (
            <div style={{ paddingTop: '0px' }}>
                <span style={{ display: isnotconnected }}>
                    <Card style={{ backgroundColor: "#444", color: "#fff", width: 270, margin: 4 }} interactive={true} elevation={Elevation.TWO}>
                        <h3><a style={{ color: "#fff" }} href="">Bienvenue {usernickname.nickname}</a></h3>
                        <p><b>Vous êtes un nouvel utilisateur ?</b></p><p>Vous pouvez vous enregistrer directement en appuyant sur le bouton ci-dessous</p>
                        <p></p>
                        <Button onClick={handleOpen}>Créer votre compte</Button>
                    </Card>
                    <Card style={{ backgroundColor: "#444", color: "#fff", width: 270, margin: 4 }} interactive={true} elevation={Elevation.TWO}>
                        <h3><a style={{ color: "#fff" }} href="">Vous connecter</a></h3>
                        <p><b>Vous êtes déjà enregistré ?</b></p><p>Vous pouvez vous connecter en appuyant sur le bouton ci-dessous</p>
                        <p><a></a></p>

                        <Button onClick={handleOpenLogin}>Se connecter</Button>

                        <MultistepDialog
                            className="signin"
                            icon="info-sign"
                            title="Créer un compte"
                            onClose={handleClose}
                            onChange={handleChange}
                            isOpen={isOpenSign}
                            nextButtonProps={{ disabled: state.value === undefined }}
                            finalButtonProps={{ onClick: handleSendCnx, disabled: state.isValidSignin === undefined }}
                        >
                            <DialogStep
                                id="idstep1"
                                panel={<PanelChoixType selectedValue={state.value} onChange={handleSelectionChange} />}
                                title="Type d'utilisateur"
                            />
                            <DialogStep
                                id="idstep2"
                                panel={<PanelNom selectedValue={state.value} usertype={usertype} onChange={handleSelectionChange} />}
                                title="Nom et prénom"
                            />
                            <DialogStep
                                id="idstep3"
                                panel={<PanelIdentifiant usernom={usernom} userprenom={userprenom} etape="Identifiant" selectedValue={state.value} onChange={handleSelectionChange} />}
                                title="Identifiant"
                            />
                            <DialogStep
                                id="idstep4"
                                panel={<PanelPassword selectedValue={state.value} onChange={handleSelectionChange} />}
                                title="Mot de passe"
                            />
                        </MultistepDialog>
                        <MultistepDialog
                            style={{ minWidth: 380, width: 380 }}
                            className="login"
                            icon="info-sign"
                            title="S'identifier"
                            onClose={handleCloseLogin}
                            onChange={handleChangeLogin}
                            isOpen={isOpenLogin}
                            nextButtonProps={{ disabled: state.value === undefined }}
                            finalButtonProps={{ onClick: handleSendCnxLogin, disabled: state.isValidLogin === undefined }}
                        //finalButtonProps={{onClick:{ handleClose}},{text: "Envoyer"},{disabled:state.isValidSignin === undefined}}
                        // title={hasTitle ? "Multistep dialog" : undefined}
                        // {...state}
                        >
                            <DialogStep
                                id="idstep1"
                                panel={<PanelEmailEtPassword etape="Etape 1" selectedValue={state.value} onChange={handleSelectionGetLogin} />}
                                title="Email"
                            />
                            {/*<DialogStep
        id="idstep2"
        panel={<PanelOnePassword selectedValue={state.value} onChange={handleSelectionChangeLogin}/>}
        title="Mot de passe"
     />*/}
                        </MultistepDialog>
                    </Card>
                </span>

            </div>);
    }
}
